import { render, staticRenderFns } from "./hint-box.vue?vue&type=template&id=3bd8c502&"
import script from "./hint-box.vue?vue&type=script&setup=true&lang=js&"
export * from "./hint-box.vue?vue&type=script&setup=true&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports